import { Box, Button, Typography, useTheme } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from 'react';

import fileDownload from 'js-file-download';
import { useAxiosPrivate } from '../../../hooks';

const CreditReport = () => {
  const theme = useTheme();
  const axiosPrivate = useAxiosPrivate();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadCreditReport = () => {
    setIsDownloading(true);

    axiosPrivate
      .get('/reports/credits-applied', {
        responseType: 'blob',
      })
      .then((response) => {
        fileDownload(
          response.data,
          `expo-credits-report-${new Date().toISOString()}.xlsx`,
        );
      })
      .catch((error: Error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  return (
    <Box>
      <Typography
        variant="h4"
        className="manager-report-title"
        sx={{ marginBottom: theme.spacing(1) }}
      >
        EXPO Report Name
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={
          isDownloading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <DownloadIcon />
          )
        }
        onClick={downloadCreditReport}
        disabled={isDownloading}
        sx={{
          marginTop: theme.spacing(2),
          padding: theme.spacing(1, 3),
          backgroundColor: '#0070BA',
          '&:hover': {
            backgroundColor: '#005A9E',
          },
          '&.Mui-disabled': {
            backgroundColor: '#0070BA80',
          },
        }}
      >
        {isDownloading ? 'Downloading...' : 'Download Credits Report'}
      </Button>
    </Box>
  );
};

export default CreditReport;
